// src/utils/globalStyles.js

import { createGlobalStyle } from 'styled-components';

import Rawline400 from '../assets/fonts/Rawline/rawline-400.ttf';
import Rawline500 from '../assets/fonts/Rawline/rawline-500.ttf';
import Rawline600 from '../assets/fonts/Rawline/rawline-600.ttf';
import Rawline700 from '../assets/fonts/Rawline/rawline-700.ttf';
import Rawline800 from '../assets/fonts/Rawline/rawline-800.ttf';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Rawline';
    src: local('Rawline'), url(${Rawline400});
    font-weight: 400;
  }

  @font-face {
    font-family: 'Rawline';
    src: local('Rawline'), url(${Rawline500});
    font-weight: 500;
  }

  @font-face {
    font-family: 'Rawline';
    src: local('Rawline'), url(${Rawline600});
    font-weight: 600;
  }

  @font-face {
    font-family: 'Rawline';
    src: local('Rawline'), url(${Rawline700});
    font-weight: 700;
  }

  @font-face {
    font-family: 'Rawline';
    src: local('Rawline'), url(${Rawline800});
    font-weight: 800;
  }


  body {
    font-family: 'Rawline', sans-serif;
    font-weight: 400;
  }

  /* Global scrollbar styling */
  ::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vh;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.scrollbar.track || '#f1f1f1'};
    opacity: 1;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.scrollbar.thumb || '#888'};
    border-radius: 10px;
    opacity: 50%;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.scrollbar.thumbHover || '#555'};
  }
`;

export default GlobalStyle;
